/* eslint-disable no-unused-vars */
import React from "react";
import "./Home.css";
//assets
import img1 from "../../Assets/img1.png";
import img2 from "../../Assets/img2.gif";
import dummy from "../../Assets/baby-gif4.gif";
function Home() {
  return (
    <div id="home" className="home">
      <img src={img1} alt="" />
      <p className="final">
        <p>
        <h1 className="dive" >DIVE INTO THE WORLD OF NFT'S</h1>
          <span>Where internet gaming and economics are combined</span>{" "}
          <br></br> Trade or hold em and evolve the pets <br></br> through
          unique gameplay
        </p>

        <div className="final-img"><img src={img2} alt="" /></div>
      </p>
    </div>
  );
}

export default Home;
